// extracted by mini-css-extract-plugin
export default {"desktopHeader":"_5xt06","headerRight":"D7Jb+","headerLeft":"Od2ok","dFlex":"M4M6o","message":"iyXw7"};